import { render, staticRenderFns } from "./GpsStats.vue?vue&type=template&id=57b47ac2&scoped=true"
import script from "./GpsStats.vue?vue&type=script&lang=js"
export * from "./GpsStats.vue?vue&type=script&lang=js"
import style0 from "./GpsStats.vue?vue&type=style&index=0&id=57b47ac2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b47ac2",
  null
  
)

export default component.exports